import { reduce, each, trim } from 'lodash-es';
/**
 * Splits a multi-line string of email addresses into an array of individual email addresses.
 * Email addresses can be separated by newlines and/or commas.
 * Empty lines and whitespace are ignored.
 * 
 * @param body - The string containing email addresses
 * @returns An array of trimmed email addresses
 */
export const splitEmailInvitesBody = (body?: string): string[] => {
  if (!body) {
    return [];
  }

  return reduce(body.split('\n'), (acc: string[], line: string) => {
    each(line.split(','), (rawEmail: string) => {
      const email = trim(rawEmail);
      if (email !== '') {
        acc.push(email);
      }
    });
    return acc;
  }, []);
}; 